
export const getHours = (entryTime, exitTime) => {
    const [entryHours, entryMinutes] = entryTime.split(':').map(Number);
    const [exitHours, exitMinutes] = exitTime.split(':').map(Number);
        return exitHours - entryHours
};
